import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  get_proforma_doc,
  update_sales_order_status,
  UpdateProfomaDoc,
} from "../../actions/orders/Action";
import close from "../../assets/cancel_w.svg";

const ProfomaDoc = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const profoma_doc = useSelector((state) => state.orders.profoma_doc);
  const update_profoma_doc = useSelector(
    (state) => state.orders.update_profoma_doc
  );
  const history = useHistory();

  useEffect(() => {
    dispatch(
      get_proforma_doc({
        email: localStorage.getItem("email"),
        sales_order: location.state?.sales_order,
      })
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (update_profoma_doc?.data?.status) {
      toast.success("Updated Status");
      dispatch({
        type: UpdateProfomaDoc.RESET,
      });
    }

    if (update_profoma_doc?.data?.status === false) {
      toast.error(update_profoma_doc?.data?.message);
      dispatch({
        type: UpdateProfomaDoc.RESET,
      });
    }
    // eslint-disable-next-line
  }, [update_profoma_doc]);

  return (
    <div className="profoma-doc">
      <div className="profoma-header">
        <div>
          <span>Order ID - {location.state?.order_no}</span>
          <span>
            {location.state?.time} | ${location.state?.amount}
          </span>
        </div>
        <div className="flex-center">
          <button
            className="approve-btn mr2"
            onClick={() => {
              dispatch(
                update_sales_order_status({
                  order_id: location.state?.order_id,
                  so_number: location.state?.sales_order,
                  sales_order_status: "accept",
                })
              );
            }}
          >
            Approve
          </button>
          <button
            className="reject-btn mr2"
            onClick={() => {
              dispatch(
                update_sales_order_status({
                  order_id: location.state?.order_id,
                  so_number: location.state?.sales_order,
                  sales_order_status: "reject",
                })
              );
            }}
          >
            Reject
          </button>
          <img
            src={close}
            alt={"close"}
            width={20}
            onClick={() => history.goBack()}
          />
        </div>
      </div>
      <embed
        src={"data:application/pdf;base64," + profoma_doc?.data?.pdf_content}
      />
    </div>
  );
};

export default ProfomaDoc;
